import { PlusOutlined } from "@ant-design/icons";
import { Alert, Button, Typography } from "antd";
import { ConversionPixelsTable } from "components/Tables/ConversionPixelsTable/ConversionPixelsTable.tsx";
import { CustomDomainsTable } from "components/Tables/CustomDomainsTable/CustomDomainsTable.tsx";
import { AddButton } from "components/UI/Table/UI/AddButton/AddButton.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useUser } from "hooks/useUser.ts";
import { PermissionEnum } from "types/enums";
import { DrawerId, FormId } from "types/models.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getSettingHeaderItems } from "utils/tenantHeaderItems.ts";

const { Title } = Typography;

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/setting/_layout/tracking/")({
    component: TrackingSettingsPage,
    staticData: {
        permissions: [PermissionEnum.SettingTracking],
        showInSideMenu: false,
        label: "pages.setting.tracking.title",
    },
});

function TrackingSettingsPage() {
    const { t: tPage } = usePaldockTranslation("pages.setting.tracking");
    const { t: tC } = usePaldockTranslation("common");
    const userUtils = useUser();
    const activeTenant = userUtils.getActiveTenant();

    if (!activeTenant) {
        // to refactor
        return <>{tC("errors.no_tenant_id")}</>;
    }

    return (
        <TenantPage headerNavigationItems={getSettingHeaderItems} isEdit={true} saveFormId={FormId.TenantSettingsForm}>
            <div className={"grid grid-cols-1 lg:grid-cols-2 gap-4"}>
                <div className={"bg-white rounded-lg p-4 w-full"}>
                    <div className={"flex items-center justify-between !mb-5"}>
                        <Title level={3}>{tPage("sections.domains.title")}</Title>
                        <AddButton drawerId={DrawerId.ManageCustomDomain} />
                    </div>
                    <Alert
                        message={tPage("sections.domains.plan_restriction")}
                        type="info"
                        showIcon
                        className="mb-4"
                    />
                    <CustomDomainsTable />
                </div>
                <div className={"bg-white rounded-lg p-4 w-full"}>
                    <div className={"flex items-center justify-between !mb-5"}>
                        <Title level={3}>{tPage("sections.conversion_pixels.title")}</Title>
                        <Button type="primary" size="small" className="px-4 py-3" disabled>
                            <PlusOutlined /> {tC("add")}
                        </Button>
                    </div>
                    <ConversionPixelsTable />
                </div>
            </div>
        </TenantPage>
    );
}
